import React from 'react'
import {connect} from 'react-redux'

import showModal from '../shared/data/actions/show_modal'

import ConversationMessageInformer from './conversation_message_informer'
import ProfileImage from '../shared/profile_image'
import ExpertRating from '../shared/expert_rating'
import ExpertSessionsCount from '../shared/expert_sessions_count'

class ExpertInfoMessageInformer extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.onRequestSessionButtonClicked = this.onRequestSessionButtonClicked.bind(this)
  }

  onRequestSessionButtonClicked (e) {
    e.preventDefault()
    this.props.showInitiateSessionModal({
      type: 'sessionInitiate',
      props: {expert: this.props.user}
    })
  }

  render () {
    return (
      <ConversationMessageInformer>
        <div className='informer-section'>
          <ProfileImage user={this.props.user} image={this.props.user.profileImage} size={64}/>
        </div>
        <div className='informer-section' style={{fontSize: '20px'}}>
          <ExpertRating rating={this.props.user.rating}/>
        </div>
      <div className='informer-section' style={{fontSize: '14px'}}>
        <ExpertSessionsCount uid={this.props.user.uid} size={16} />
        <p>sessions so far</p>
      </div>
        <div className='informer-section'>
          This expert is in expert mode.<br/>
          You must initiate a paid session to chat with him.
        </div>
        <div className='action-area'>
          <a href='#' className='button success' onClick={this.onRequestSessionButtonClicked}>Request a paid session</a>
        </div>
      </ConversationMessageInformer>
    )
  }
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    showInitiateSessionModal: (modal) => dispatch(showModal(modal))
  }
}

const ExpertInfoMessageInformerContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ExpertInfoMessageInformer)

export default ExpertInfoMessageInformerContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/expert_info_message_informer.js
 **/